module.exports = __webpack_public_path__ + "img/chad.7124a867.png";